import React from 'react';

import './aboutus.css'


const AboutUs = () => (
    <div>
  
  <div className="viaferrata-header">
            <div className="viaferrata-header__logo">    
                <img  className="viaferrata-header__logo-img"  alt="PK Greben" src="img/logo-greben.png"/> 
            </div>
        </div>
<div className="header-aboutus">
</div>

<div className="container-aboutus">   
   <div className="about-aboutus">
      <div className="left-aboutus">
         <h1 className="heading-secondary u-margin-bottom-medium heading-aboutus-page">O Nama</h1>         
         <p>Klub je osnovan aprila 2012. godine sa idejom da svojim delovanjem doprinese afirmaciji i promociji planinarskih sportskih disciplina građanima Mladenovca i Sopota,
              da promoviše obrazovnu i vaspitnu funkciju sporta, fer pleja, razumevanja, tolerancije i odgovornosti kroz bavljenje planinarenjem i sportom uopšte.
        </p>

        <p>Planinarski Klub  „GREBEN“, organizovao preko 350 planinarskih akcija kako u zemlji tako i u inostranstvu.
             Najveće i najmasovnije akcije se prave na našem Kosmaju: u aprilu (ili maju) akcija za decu “Grebenčići”- U jesen organizujemo veliku akciju 
             za planinare iz cele zemlje “S Grebenom”. Naš članovi su bili učesnici na više međunarodnih akcija u organizaciji drugih klubova i Saveza. 
             Najveći uspesi kluba su u disciplini visokogorstvo. Popeli smo sledeće vrhove: u Himalajima Island peak (6189m.);  na Kavkazu Zapadni Elbrus (5642m.) 
             koji je naviši vrh Evropskog kontinenta i Rusije (2013. i 2016.godine); Kilimandžaro (5895m.) najviši vrh Afričkog kontinenta, Tanzanije i Kenije(2018); 
             u Alpima Mont Blanc (4810m.) najviši vrh Evropske unije,Francuske i Italije (2012, 2014, 2015 i 2016.godine); Damavand (5671m.) najviši stratovulkan Azije,
              koji je ujedno i najviši vrh Irana (2016.godine); kao i najviše vrhove, Austrije, Slovenije, Balkana…  
             </p>
             <p>
             Ostale značajnije vrhove koje smo popeli možete pogledati ovde 
               <a href="/img/NasiVrhovi.pdf" download>
               <img src="/img/downloadpdf.png" alt="Nasi Vrhovi pdf" className="aboutUs-pdf-icon" />
               </a>.
             </p>    
             <p>  Sastanci su u prostorijama kluba sredom od 20h!</p>    
                 

      </div>
      <div className="right-aboutus">        
         <img srcSet="/img/about-us-small.jpg 300w, /img/about-us.jpg 1000w"
                     sizes="(max-width: 56.25em) 20vw, (max-width: 37.5em) 30vw, 300px"                                     
                     src="/img/about-us.jpg" alt="about us" />

      </div>
      <div className="clear"></div>
   </div>   
   
  

   
</div>

</div>
);


export default AboutUs;